import {isLeftBorderExceeded, isRightBorderExceeded} from "@share/presentation/helpers/BorderHelper";

export class MediaSliderState {
    posx1 = 0;
    posx2 = 0;
    posInitial = 0;
    posFinal = 0;

    threshold = 100;

    index = 0;
    activeIndex = 0;
    offset = 0;

    isShifting = false;
    isMoving = false;
    allowShift = true;

    getMovingDelta(): number {
        return this.posFinal - this.posInitial;
    }

    isLeftBorderExceeded(): boolean {
        return isLeftBorderExceeded(this.offset);
    }

    isRightBorderExceeded(totalSize: number, slideSize: number): boolean {
        return isRightBorderExceeded(this.offset, totalSize,slideSize, this.threshold);
    }

    offsetToDelta(currentOffset: number): void {
        this.offset = (currentOffset - this.posx2);
    }

    changeIndex(increment: 1 | -1, slidesLength: number): boolean {
        const newValue = this.index + increment;
        if (newValue >= 0 && newValue < slidesLength) {
            this.index = newValue;
            return true;
        }

        return false;
    }
}
